import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZImageUploadApiResponse = z.object({
  id: z.string(),
  fileName: z.string(),
  fileExtension: z.string(),
  associatedEntityId: z.string(),
  tenantId: z.string(),
  binaryData: z.string()
})

export interface ImageUploadPostRequest {
  siteId: string
  locale: string
  file: any
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZImageUploadApiResponse,
  error: z.boolean()
})

export type ImageUploadApiResponse = z.infer<typeof ZImageUploadApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function imageUpload (
  imageUploadPostRequest: ImageUploadPostRequest,
  onSuccess: (successResponse: ImageUploadApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const formData = new FormData()
  const blob = new Blob([imageUploadPostRequest.file], { type: 'application' })
  formData.append('file', blob, imageUploadPostRequest.file.name)
  const url = `/assetrest/api/v2/udp/tiq/sites/fileUpload?siteId=${imageUploadPostRequest.siteId}&locale=${imageUploadPostRequest.locale}`
  interceptedAxios
    .put(url, formData, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
